import { default as indexr7b72eukzGMeta } from "/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/index.vue?macro=true";
import { default as newsletterIFrameu2rFX5Wt8nMeta } from "/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/newsletterIFrame.vue?macro=true";
import { default as _91id_93roWUORmlczMeta } from "/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/show/[id].vue?macro=true";
import { default as show1kKk6wFCK2Meta } from "/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/show.vue?macro=true";
import { default as _91id_938CLNKLACTqMeta } from "/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/subscribe/[id].vue?macro=true";
import { default as subscribeJ9fZ60TIvXMeta } from "/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/subscribe.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "newsletterIFrame",
    path: "/newsletterIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/newsletterIFrame.vue").then(m => m.default || m)
  },
  {
    name: "show",
    path: "/show",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/show.vue").then(m => m.default || m),
    children: [
  {
    name: "show-id",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/show/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/subscribe.vue").then(m => m.default || m),
    children: [
  {
    name: "subscribe-id",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/newsletters/pages/subscribe/[id].vue").then(m => m.default || m)
  }
]
  }
]